import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const Container = styled.div`
    background:#fff;
    border:1px solid #2a848e7b;
    border-radius: 8px;
`;

export const TitleContainer = styled.div`
    padding:24px;
    border-bottom: 1px solid #0000001a;
`;

export const Title = styled.span`
    font-size: 18px;
    color:#5e5e5e;
    display:block;
`;

export const SubTitle = styled.span`
    font-size: 14px;
    color:#5e5e5e;
    display:block;
`;

export const RewardContiner = styled.div`
    padding:24px;
    display:grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap:1rem;

    
    @media (width >= 54rem){
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @media (width >= 64rem){
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    @media (width >= 90rem){
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }

    @media (width >= 145rem){
        grid-template-columns: repeat(5, minmax(0, 1fr));
    }

    @media (width >= 180rem){
        grid-template-columns: repeat(6, minmax(0, 1fr));
    }

    ${mq(Devices.mobile)} {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
`;

export const RewardItem = styled.div<{enable?:boolean}>`
    display:flex;
    flex-direction: column;
    border:1px solid ${props => props.enable?"#2a848e7b":"#0000001a"};
    border-radius: 8px;
    padding:12px;
    transition: all 0.2s ease-in-out;
    
    > span{
        font-size: 14px;
        margin-bottom:10px;
        text-align: center;
        font-weight: 400;
    }

    > svg{
        height:50px;
    }

    :hover{
        box-shadow: 0 2px 4px 1px rgba(0,0,0,0.10);
    }
`;


export const RewardTop = styled.div`
    display:flex;
    justify-content: space-between;
`;

export const CoinBar = styled.div<{enable?:boolean}>`
    display:flex;
    align-items: center;
    justify-content: space-between;
    background:${props => props.enable?"#2a848e24":"#2a848e13"};
    border-radius: 20px;
    padding:0 6px;

    span{
       color:#2a848e; 
       display:flex;
        align-items: center;
        gap:4px;
    }
    
    svg{
        height:10px;
        path {
            stroke:#2a848e;
        }
    }
`;

export const ProgressBar = styled.div<{progress?:number}>`
    height:8px;
    width:100%;
    margin:8px 0;
    content: ' ';
    border-radius: 10px;
    overflow:hidden;
    background:#2a848e24;

    > div{
        content: ' ';
        background:#2a848e;
        background: linear-gradient(90deg, rgba(42, 132, 142, 1) 0%, #2fb3c2 100%);
        width:${props => props.progress?props.progress + "%":"0px"};
        height:100%;
        border-radius: 10px;
        overflow:hidden;
    }
`;

export const RedeemButton = styled.button<{enable?:boolean}>`
    background:${props => props.enable?"#2a848e":"#cdd2da"};
    color:#fff;;
    border-radius: 6px;
    display:flex;
    align-items: center;
    justify-content: center;
    gap:10px;
    font-size: 14px;
    font-weight: 500;
    padding:10px;
    transition: all 0.2s ease-in-out;
    pointer-events: ${props => props.enable?"all":"none"};

    > svg{
        height:16px;
        path {
            stroke:#fff;
        }
    }

    :hover{
        opacity:${props => props.enable?"0.8":"1"};
    }
`;

export const ModalContainer = styled.div`
    background:#fff;
    border-radius: 8px;
    position: relative;
    display:flex;
    flex-direction: column;
    align-items: center;
    max-width:448px;
    width:100%;
    min-width: 250px;
    padding:20px;
    margin: 0 20px;
    min-height: 180px;
`;

export const SuccessContainer = styled.div`
    background:#fff;
    border-radius: 8px;
    position: relative;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width:448px;
    width:100%;
    min-width: 250px;
    padding:20px;
    margin: 0 20px;
    min-height: 280px;

    span{
        
        :nth-of-type(1){
            font-size: 24px;
        }
        :nth-of-type(2){
            font-size: 18px;
        }
    }
`;

export const CloseButton = styled.div`
    position: absolute;
    top:20px;
    right:20px;
    cursor: pointer;

    svg{
        width:10px;
        path{
            fill:#9c9c9c;
        }
    }
`;


export const ModalTitle = styled.span`
    font-size: 20px;
    font-weight: 500;
    color:#3a3a3a;
    padding:0 20px;
    text-align: center;
`;

export const ModalSubTitle = styled.span`
    font-size: 14px;
    color:#686868;
    margin-bottom:20px;
    text-align: center;
`;

export const ModalText = styled.p`
    font-size: 16px;
    color:#444444;
    margin-bottom:20px;
    text-align: center;
    padding-top:16px;
    padding-bottom: 8px;
`;

export const ImageContainer = styled.div`
    position: relative;
    width:160px;
    height:160px;
    border:5px solid #2a848e;
    border-radius: 50%;
    overflow: hidden;
`;

export const StudentName = styled.span`
    font-size: 20px;
    font-weight: 500;
    color:#3a3a3a;
    margin-top: 20px;
`;

export const RewardBox = styled.div`
    width:100%;
    background:#e0e9ea7f;
    border:1px solid #2a848e2d;
    display:flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding:12px;
    border-radius: 8px;
    margin-top: 12px;
    
    span{
        font-size: 16px;
        color:#64748b;
    }

    svg{
        width:70px;
    }
`;

export const Balance = styled.div`
    width:100%;
    background:#EEF0F2;
    border:1px solid #EEF0F2;
    display:flex;
    justify-content: space-between;
    align-items: center;
    padding:12px;
    border-radius: 8px;
    margin-top: 20px;
    
    span{
        font-size: 16px;
        color:#64748b;
    }

    svg{
        width:12px;
        path {
            stroke:#64748b;
        }
    }
`;

export const RewardCost = styled.div`
    width:100%;
    background:#F5E4E5;
    border:1px solid #fa505e22;
    display:flex;
    justify-content: space-between;
    align-items: center;
    padding:12px;
    border-radius: 8px;
    margin-top: 12px;
    
    span{
        font-size: 16px;
        color:#fa505e;
    }

    svg{
        width:12px;
        path {
            stroke:#fa505e;
        }
    }
`;

export const NewBalance = styled.div`
    width:100%;
    background:#e0e9ea7f;
    border:1px solid #2a848e2d;
    display:flex;
    justify-content: space-between;
    align-items: center;
    padding:12px;
    border-radius: 8px;
    margin-top: 12px;
    margin-bottom: 20px;
    
    span{
        font-size: 16px;
        color:#2a848e;
    }

    svg{
        width:12px;
        path {
            stroke:#2a848e;
        }
    }
`;


export const ModalButtons = styled.div`
    width:100%;
    display:flex;
    gap:12px;
`;


const ModalButton = styled.button`
    width:100%;
    font-size:16px;
    border-radius: 6px;
    padding:6px;
    color:#fff;
    font-weight: 500;
    transition: all 0.2s ease-in-out;
`;


export const ModalCancel = styled(ModalButton)`
    background:#fa505ebe;
    :hover{
        background:#fa505e;
    }
`;


export const ModalAccept = styled(ModalButton)`
    background:#2a848eb2;
    :hover{
        background:#2a848e;
    }
`;